import React from 'react';
import { Reveal } from './Reveal';
import { volumes } from '../data/content';
export function WhatsInside() {
  return <section className="w-full bg-cream px-5 pb-24 sm:pb-32" data-id="element-230" data-mp="yupm2ycqqz3s">
      <div className="mx-auto w-full max-w-[1120px]" data-id="element-231" data-mp="kwhsn0ewyfxd">
        <Reveal data-id="element-232" data-mp="kvzozipx8zff">
          <h2 className="mx-auto max-w-3xl text-center font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-navy sm:text-5xl" data-id="element-233" data-mp="kyc7py3i7dtj">
            Hvad indeholder Håndboldklar?
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-234" data-mp="fwwj5w24ap6e">
          <p className="mx-auto mt-6 max-w-[620px] text-center text-base leading-relaxed text-muted" data-id="element-235" data-mp="fy6ispomc5f5">
            Seks bind. Ét til hver aldersgruppe, bygget oven på den officielle spilform,
            som netop din række spiller.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-236" data-mp="3ocyg2crs5o3e">
          {volumes.map((volume, index) => <Reveal as="li" key={volume.number} delay={index % 3 * 0.06} data-id="element-237" data-mp="3tcktam7lz4c7" data-mpi={index}>
              <article className="flex h-full flex-col rounded-card border border-line bg-white p-7 shadow-card" data-id="element-238" data-mp="3ctxk6wft6d2h">
                <p className="font-display text-sm font-bold uppercase tracking-[0.18em] text-gold" data-id="element-239" data-mp="37vcistotlncg">
                  {volume.number}
                </p>
                <p className="mt-1 font-display text-sm font-bold uppercase tracking-[0.18em] text-muted" data-id="element-240" data-mp="3ltsyha4nuo6q">
                  {volume.age}
                </p>
                <h3 className="mt-3 font-display text-3xl font-bold uppercase leading-none tracking-tight text-navy" data-id="element-241" data-mp="2u2mzix0oewj1">
                  {volume.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-ink" data-id="element-242" data-mp="32vhsoscvd1sg">{volume.body}</p>
                <p className="mt-auto border-t border-line pt-4 text-sm text-muted" data-id="element-243" data-mp="32xkq3xgcpx77">
                  {volume.meta}
                </p>
              </article>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}